
import {
    BrowserRouter as Router,
    Route,
    Routes,
} from "react-router-dom";


import Dashboard  from './pages/dashboard'
import Viewer from './pages/viewer'
import Producer from './pages/producer'
import InfosCard from "./component/infos_card";

function App() {

    return (
        <>
        <Router>
            <Routes>             
                <Route path="/dashboard" element={<Dashboard  />} />                       
                <Route path="/producer" element={<Producer />} />            
                <Route path="/:roomID" element={<Viewer />} />            
                <Route path="*" element={<InfosCard text={'Error 404'}/>} />            
            </Routes>
        </Router>
        </>
    );

}

export default App;